// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
    obj = obj - 0;
    /* biome-ignore lint/suspicious/noSelfCompare: Necessary for this camelize function */
    return obj === obj;
}
export default function camelize(string) {
    if (_isNumerical(string)) {
        return string;
    }
    // eslint-disable-next-line no-useless-escape
    string = string.replace(/[-_\s]+(.)?/g, (match, chr) => chr ? chr.toUpperCase() : "");
    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
//# sourceMappingURL=camelize.js.map